"use strict";
var React = require('react')
var Link = require('react-router')
var LanguageStore = require('../../store/LanguageStore')
var DocMeta = require('react-doc-meta');

var Onama = React.createClass({
componentDidMount() {
      LanguageStore.addChangeListener(this.onChange);
    },
    getInitialState() {
        var state = LanguageStore.getLanguage();
        return state;
    },
    onChange() {
        var state = LanguageStore.getLanguage();
        this.setState(state);
    },
    componentWillUnmount() {
        LanguageStore.removeChangeListener(this.onChange);
    },
    srb(){
      document.title = 'O nama | Termovent SC Livnica čelika A.D. Bačka Topola'
      var tags = [
      {name: "description", content: "Termovent SC Livnica čelika AD je javno akcionarsko društvo sa sedištem u Bačkoj Topoli. Bavi se proizvodnjom odlivaka od čeličnog liva i zapošljava oko 200 radnika."},
      {name: "keyword", content: "Termovent,celik,livnica,celicni liv,menadzment,backa topola,srbija"},
      {itemProp: "name", content: "O nama | Termovent SC Livnica čelika A.D. Bačka Topola"},
      {itemProp: "description", content: "Termovent SC Livnica čelika AD je javno akcionarsko društvo sa sedištem u Bačkoj Topoli. Bavi se proizvodnjom odlivaka od čeličnog liva i zapošljava oko 200 radnika."},
      {itemProp: "image", content: "http://www.livnica.com/img/slik1.jpg"},
      {name: "twitter:title", content: "O nama | Termovent SC Livnica čelika A.D. Bačka Topola"},
      {name: "twitter:description", content: "Termovent SC Livnica čelika AD je javno akcionarsko društvo sa sedištem u Bačkoj Topoli. Bavi se proizvodnjom odlivaka od čeličnog liva i zapošljava oko 200 radnika."},
      {name: "twitter:creator", content: "Termovent SC Livnica čelika A.D. Bačka Topola"},
      {name: "twitter:image", content: "http://www.livnica.com/img/slik1.jpg"},
      {property: "og:type", content: "website"},
      {property: "og:title", content: "O nama | Termovent SC Livnica čelika A.D. Bačka Topola"},
      {property: "og:url", content: "http://www.livnica.com/"},
      {property: "og:image", content: "http://www.livnica.com/img/slik1.jpg"},
      {property: "og:description", content: "Termovent SC Livnica čelika AD je javno akcionarsko društvo sa sedištem u Bačkoj Topoli. Bavi se proizvodnjom odlivaka od čeličnog liva i zapošljava oko 200 radnika."},
      {property: "og:site_name", content: "Termovent SC Livnica čelika A.D. Bačka Topola"},
    ]
      return (<DocMeta tags={tags}>
      <div className='container'>
        <div className='index-content row '>
          <h1 className='onamaHeading text-center'>O NAMA</h1>
          <div className='index-content col-md-6 '>
            <img className='onamaPic' src='img/slik1.jpg' alt='Livenje'/>
          </div>
          <div className='index-content col-md-6 '>
            <p>Termovent SC Livnica čelika AD je javno akcionarsko društvo sa sedištem u Bačkoj Topoli. Bavi se proizvodnjom odlivaka od čeličnog liva i zapošljava oko 200 radnika. Svoje proizvode plasira sa podjednakim uspehom kako na domaćem, tako i na inostranom tržištu. </p>
            <p>Davne 1963. godine Livnica je poslovala u sastavu velikog metalurškog kompleksa "Jelšingrad" iz Banja Luke. Godine 1998. među prvima je transformisana u akcionarsko društvo, a 2003. godine, u procesu privatizacije, D.O.O. "Termovent SC" iz Temerina postao je najznačajniji strateški partner Livnice i njen većinski vlasnik.</p>
            <p>U vlasničkoj strukturi Termovent SC Livnica čelika AD fizička lica učestvuju sa 33.46%, a pravna lica sa 66.54% od čega je 60.10% osnovnog kapitala u vlasništvu D.O.O. "Termovent SC". Sve akcije livnice uključene su u trgovanje na MTP Belex. </p>
          </div>
           <div className='col-md-6'>
              <h3 className='onamaHeading2 text-center'>Organizaciona struktura</h3>
              <p>Termovent SC Livnica čelika AD svoju delatnost ostvaruje na nivou sektora, kojih je ukupno pet, i to :</p>
              <ul className="list-group text-center onamaList">
                <li className="list-group-item">Upravljanje kvalitetom</li>
                <li className="list-group-item">Tehnički sektor</li>
                <li className="list-group-item">Sektor komercijale</li>
                <li className="list-group-item">Sektor pravnih, kadrovskih i opštih poslova</li>
                <li className="list-group-item">Sektor ekonomsko finansijskih poslova</li>
              </ul>
              <p>Sektorima rukovode direktori.</p>
           </div>
           <div className='col-md-6'>
              <h3 className='onamaHeading2 text-center'>Menadžment</h3>
              <p>U Termovent SC Livnica Čelika AD upravljanje je jednodomno. Organi upravljanja su Skupština akcionara i odbor direktora. Skupština bira i imenuje članove odbora direktora na mandatni period od četiri godine. Funkcija predsednika odbora direktora poverena je Aleksandru Crnogorcu, a članovi su Mirjana Ivanović i Milan Balać. </p>
              <p>Menadžment Livnice usvojio je 25.04.2013.godine Kodeks korporativnog upravljanja PKS, objavljen na sajtu Privredne komore Srbije i od tada ga primenjuje. Osim toga, Livnica je još 2008.godine usvojila je vlastiti Kodeks poslovnog ponašanja zaposlenih kojim je bliže uredila norme ponašanja i poslovne komunikacije.</p>
           </div>
        </div>
      </div>
      </DocMeta>
    )
    },
    eng(){
      document.title = 'About Us | Termovent SC Steal foundry J.S.C Backa Topola'
      var tags = [
      {name: "description", content: "Termovent SC Steel foundry J.S.C is a public joint-stock company based in Backa Topola. It is engaged in the production of Steel castings and employs about 200 workers."},
      {name: "keyword", content: "Termovent SC,Steel,foundry,Steel casting,Management,backa topola, serbia"},
      {itemProp: "name", content: "About Us | Termovent SC Steal foundry J.S.C Backa Topola"},
      {itemProp: "description", content: "Termovent SC Steel foundry J.S.C is a public joint-stock company based in Backa Topola. It is engaged in the production of Steel castings and employs about 200 workers."},
      {itemProp: "image", content: "http://www.livnica.com/img/slik1.jpg"},
      {name: "twitter:title", content: "About Us | Termovent SC Steal foundry J.S.C Backa Topola"},
      {name: "twitter:description", content: "Termovent SC Steel foundry J.S.C is a public joint-stock company based in Backa Topola. It is engaged in the production of Steel castings and employs about 200 workers."},
      {name: "twitter:creator", content: "Termovent SC Steel foundry"},
      {name: "twitter:image", content: "http://www.livnica.com/img/slik1.jpg"},
      {property: "og:type", content: "website"},
      {property: "og:title", content: "About Us | Termovent SC Steal foundry J.S.C Backa Topola"},
      {property: "og:url", content: "http://www.livnica.com/"},
      {property: "og:image", content: "http://www.livnica.com/img/slik1.jpg"},
      {property: "og:description", content: "Termovent SC Steel foundry J.S.C is a public joint-stock company based in Backa Topola. It is engaged in the production of Steel castings and employs about 200 workers."},
      {property: "og:site_name", content: "Termovent SC Steel foundry J.S.C"},
    ]
      return (<DocMeta tags={tags}>
      <div className='container'>
        <div className='index-content row '>
          <h1 className='onamaHeading text-center'>ABOUT US</h1>
          <div className='index-content col-md-6 '>
            <img className='onamaPic' src='img/slik1.jpg' alt='Steel Casting in Backa Topola,Serbia'/>
          </div>
          <div className='index-content col-md-6 '>
            <p>Termovent SC Steel foundry J.S.C is a public joint-stock company based in Backa Topola. It is engaged in the production of Steel castings and employs about 200 workers. Markets its products with equal success on the domestic and foreign market. </p>
            <p>Back in 1963, the foundry has been operating within the large metallurgical complex "Jelšingrad" from Banja Luka. In 1998, the first of which is transformed into a joint stock company, and in 2003, during the privatization process, Ltd "Termovent SC" from Temerin has become the most important strategic partner of the foundry and its majority owner.</p>
            <p>In the ownership structure of Termovent SC Steel foundry J.S.C natural persons participate with 33.46% and legal entities with 66.54% of which 60.10% of the share capital owned by LLC "Termovent SC". All shares of the foundry are included in trading on the MTF(Multilateral Trading Facility) Belex.</p>
          </div>
           <div className='col-md-6'>
              <h3 className='onamaHeading2 text-center'>The organizational structure</h3>
              <p>Termovent SC Steel foundry structure consists of five sectors :</p>
              <ul className="list-group text-center onamaList">
                <li className="list-group-item">Quality management</li>
                <li className="list-group-item">Technical department</li>
                <li className="list-group-item">Commercial department</li>
                <li className="list-group-item">Legal, Personnel and General Affairs</li>
                <li className="list-group-item">Department for Economic and Financial Affairs</li>
              </ul>
              <p>Sectors are managed by directors.</p>
           </div>
           <div className='col-md-6'>
              <h3 className='onamaHeading2 text-center'>Management</h3>
              <p>Termovent SC Steel foundry J.S.C management Is organized as unicameral. The management bodies are the Shareholders Assembly and the Board of Directors. The Assembly elects and appoints the members of the Board of Directors for a four-year term. President of the Board of Directors is Aleksandar Crnogorac and the members are Mirjana Ivanovic and Milan Balac.</p>
              <p>Foundry Management has been applying a Code of Corporate Governance PKS  since 23.04.2013.  In addition, foundry  formulated its own Code of Business Conduct in 2008, which more precisely regulated the standards of conduct and business communications.</p>
           </div>
        </div>
      </div>
      </DocMeta>
    )
    },
    ger(){
      document.title = 'ÜBER UNS | Die Termovent SC Stahlfabrik GmbH'
      var tags = [
      {name: "description", content: "Die Termovent SC Stahlfabrik GmbH ist eine Aktiengesellschaft mit ihrem Sitz in Backa Topola. Sie produziert Stahlgusse und hat  an die  zweihundert Angestellte."},
      {name: "keyword", content: "Termovent SC,Stahlfabrik,Stahlgusse,Management,über uns, Serbien"},
      {itemProp: "name", content: "ÜBER UNS | Die Termovent SC Stahlfabrik GmbH"},
      {itemProp: "description", content: "Die Termovent SC Stahlfabrik GmbH ist eine Aktiengesellschaft mit ihrem Sitz in Backa Topola. Sie produziert Stahlgusse und hat  an die  zweihundert Angestellte."},
      {itemProp: "image", content: "http://www.livnica.com/img/slik1.jpg"},
      {name: "twitter:card", content: "product"},
      {name: "twitter:site", content: "@publisher_handle"},
      {name: "twitter:title", content: "ÜBER UNS"},
      {name: "twitter:description", content: "Die Termovent SC Stahlfabrik GmbH ist eine Aktiengesellschaft mit ihrem Sitz in Backa Topola. Sie produziert Stahlgusse und hat  an die  zweihundert Angestellte."},
      {name: "twitter:creator", content: "Termovent SC Stahlfabrik GmbH"},
      {name: "twitter:image", content: "http://www.livnica.com/img/slik1.jpg"},
      {property: "og:type", content: "website"},
      {property: "og:title", content: "ÜBER UNS"},
      {property: "og:url", content: "http://www.livnica.com/"},
      {property: "og:image", content: "http://www.livnica.com/img/slik1.jpg"},
      {property: "og:description", content: "Die Termovent SC Stahlfabrik GmbH ist eine Aktiengesellschaft mit ihrem Sitz in Backa Topola. Sie produziert Stahlgusse und hat  an die  zweihundert Angestellte."},
      {property: "og:site_name", content: "Die Termovent SC Stahlfabrik GmbH"},
    ]
      return (
      <DocMeta tags={tags}>
      <div className='container'>
        <div className='index-content row '>
          <h1 className='onamaHeading text-center'>ÜBER UNS</h1>
          <div className='index-content col-md-6 '>
            <img className='onamaPic' src='img/slik1.jpg' alt='Produziert Stahlgusse'/>
          </div>
          <div className='index-content col-md-6 '>
            <p>Die Termovent SC Stahlfabrik GmbH ist eine Aktiengesellschaft mit ihrem Sitz in Backa Topola. Sie produziert Stahlgusse und hat  an die  zweihundert Angestellte. Die Fabrik ist nicht nur im Binnenmarkt sondern auch im Auslandsmarkt sehr erfolgreich.</p>
            <p>Seit ihrer Gründung  im Jahr 1963 war die Stahlfabrik ein Teil des großen metallurgischen Fabrikkomplexes „Jelsingrad“ aus Banja Luka. 1998 war die Stahlfabrik eine der ersten Firmen, die in eine Aktiengesellschaft transormiert wurde.  Seit des Pravitisierungsprozesses im Jahr 2001 ist der Termovent SC Temerin der wichtigste  geschäftsstrategische Partner und  großter Teilinhaber der Stahlfabrik geworden. </p>
            <p>Die Eigentümerstruktur besagt, dass natürliche Personen mit 33,46% und Rechtsträger mit 66, 54% (von dessen GmbH Termovent SC mit 60,10%) partizipiert werden. Alle Aktien von Die Stahlfabrik sind im Handel des multilateralen Handelssystems Belex inkludiert.</p>
          </div>
           <div className='col-md-6'>
              <h3 className='onamaHeading2 text-center'>Managementstruktur</h3>
              <p>Die Manegementstruktur des Termovent SC Stahlfabrik ist in fünf Abteilungen gegliedert:</p>
              <ul className="list-group text-center onamaList">
                <li className="list-group-item">Qualitätsmanagement</li>
                <li className="list-group-item">Fachabteilung</li>
                <li className="list-group-item">Handelsabteilung</li>
                <li className="list-group-item">Rechts-, Personal- und Allgemeinabteilung</li>
                <li className="list-group-item">Wirtschafts- und Finanzabteilung</li>
              </ul>
              <p>Jede Abteilung wird von einem Abteilungsmanager geleitet.</p>
           </div>
           <div className='col-md-6'>
              <h3 className='onamaHeading2 text-center'>Management</h3>
              <p>Die Termovent SC Stahlfabrik GmbH ist als ein Einkammeral organisiert.
              Managementorgane sind die Aktionärsversammlung und Verwaltungsrat. Die Aktionärsversammlung soll Mitglieder des Verwaltungsrats auf eine vierjährige  Amtszeit wählen und berufen. Der Präsident  des Verwaltungsrats ist Slobodan Crnogorac und die Mitglieder sind Mirjana Ivanovic und Milan Balac.
              </p>
              <p>Seit 23.04.2013 verwendet Stahlfabriks Management den Corporate Governance PKS Kodex. Zusätzlich hat die Stahlfabrik 2008 ihren eigenen Verhaltenskodex gegründet.</p>
           </div>
        </div>
      </div>
      </DocMeta>
    )
    },
  render() {

    return(

       this.state.lang === 'uk' ? this.eng() : this.state.lang === 'rs' ? this.srb() : this.state.lang === 'de' ? this.ger() : null

    )
  }
})

module.exports = Onama;



/** WEBPACK FOOTER **
 ** ./modules/components/Onama/Onama.js
 **/